export default __webpack_public_path__ + "static/media/icon-fermeture-tag.aeb55831.svg";